/**
 * 活动开放时间 时间戳
 * 1633078800000
 * @type {number}
 */

export const ActivityStartTime = 1633078800000
